<template>
  <div class="popups">
      <div class="popups-img">
        <img :src="imgUrl" alt="">
        <div class="closeBtn" @click="closePopups">
          <img src="../../assets/popupClose.png" alt="">
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    props: {
      imgUrl:{
        type:String,
        default:''
      },
      isShow:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {
      closePopups(){
        this.$emit('closePopups')
      }
    }
  }
</script>

<style scoped lang="less">
.popups{
  position: fixed;
  background-color: rgba(0,0,0,0.5);
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0 14px;
  box-sizing: border-box;
  overflow:auto;
  & .popups-img{
    width: 1200px;
    position: absolute;
    max-height: 800px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    & img{
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
  & .closeBtn{
    width: 55px;
    height: 55px;
    position: absolute;
    top: -20px;
    right: -20px;
  & img{
    width: 100%;
    height: 100%;
  }
  }
}
</style>